import { BASE_PATH_2_QUERY, NEXT_SECTIONS_QUERY } from '@glass/common/modules/pages/queryParams';
import stepData, {
  DELIMITER,
  isValidBuilderSection,
} from '@glass/web/modules/resumes/router/stepData';
import { INTRO_STEP } from '@glass/web/modules/resumes/steps';

import getBuilderSectionStepParams from '@glass/shared/components/Link/ResumeBuilderLink/getBuilderSectionStepParams';

const isDebug = process.env.NEXT_PUBLIC_DEBUG === 'builder';

const getBuilderNextSectionParams = ({
  [BASE_PATH_2_QUERY]: currentSection,
  [NEXT_SECTIONS_QUERY]: overrideNextSection = '',
  ...other
}) => {
  if (!currentSection || !stepData[currentSection]) {
    if (isDebug) {
      console.warn(`invalid current section ${currentSection}`);
    }
    return {};
  }

  const [nextOverride, ...overrideArray] = overrideNextSection.split(DELIMITER);
  const nextSection =
    nextOverride && isValidBuilderSection(nextOverride)
      ? nextOverride
      : stepData[currentSection].nextSection;

  const nextSectionParams = getBuilderSectionStepParams({
    [BASE_PATH_2_QUERY]: nextSection,
    skip: overrideNextSection ? [INTRO_STEP] : [],
    ...other,
  });

  const nextQuery =
    nextSection === nextOverride ? overrideArray.join(DELIMITER) : overrideNextSection || undefined;

  if (nextQuery) {
    nextSectionParams[NEXT_SECTIONS_QUERY] = nextQuery;
  }

  return nextSectionParams;
};

export default getBuilderNextSectionParams;
